import React from 'react'
import PropTypes from 'prop-types'
import { indexMap } from '@helpers'
import Filter from './Filter'
import './Filters.module.scss'

const Filters = ({ filters, currentFilter, applyFilter }) => {
  const sorting = ([x, ...xs]) => [x, ...xs.sort()]
  const sortedFilters = sorting(filters)

  return (
    <div styleName='filters'>
      {indexMap((filter, index) => (
        <Filter
          filter={filter}
          key={index}
          applyFilter={() => applyFilter(filter)}
          selected={filter === currentFilter}
        />
      ), sortedFilters)}
    </div>
  )
}

Filters.propTypes = {
  filters: PropTypes.array.isRequired,
  currentFilter: PropTypes.string,
  applyFilter: PropTypes.func.isRequired
}

export default Filters



// WEBPACK FOOTER //
// ./src/components/Filters/Filters.js